// Light theme configuration for Flowbite React components
export const lightTheme = {
  navbar: {
    root: {
      base: "bg-white border-gray-200 px-2 py-2.5 sm:px-4 border-b",
      rounded: {
        on: "rounded",
        off: ""
      },
      bordered: {
        on: "border",
        off: ""
      },
      inner: {
        base: "mx-auto flex flex-wrap items-center justify-between bg-white",
        fluid: {
          on: "bg-white",
          off: "container bg-white"
        }
      }
    },
    brand: {
      base: "flex items-center bg-white"
    },
    collapse: {
      base: "w-full md:block md:w-auto bg-white",
      list: "mt-4 flex flex-col p-4 md:mt-0 md:flex-row md:space-x-8 md:p-0 md:text-sm md:font-medium bg-white",
      hidden: {
        on: "hidden",
        off: "bg-white"
      }
    },
    link: {
      base: "block py-2 pr-4 pl-3 md:p-0 bg-white",
      active: {
        on: "bg-cyan-700 text-white md:bg-transparent md:text-cyan-700",
        off: "border-b border-gray-100 text-gray-700 hover:bg-gray-50 md:border-0 md:hover:bg-transparent md:hover:text-cyan-700"
      },
      disabled: {
        on: "text-gray-400 hover:cursor-not-allowed",
        off: ""
      }
    },
    toggle: {
      base: "inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 bg-white",
      icon: "w-6 h-6"
    }
  },
  sidebar: {
    root: {
      base: "h-full bg-white border-r border-gray-200",
      collapsed: {
        on: "w-16 bg-white",
        off: "w-64 bg-white"
      },
      inner: "h-full overflow-y-auto overflow-x-hidden bg-white px-3 py-4 border-r border-gray-200"
    },
    collapse: {
      button: "group flex w-full items-center rounded-lg p-2 text-base font-normal text-gray-900 transition duration-75 hover:bg-gray-100 bg-white",
      icon: {
        base: "h-6 w-6 text-gray-500 transition duration-75 group-hover:text-gray-900",
        open: {
          off: "",
          on: "text-gray-900"
        }
      },
      label: {
        base: "ml-3 flex-1 whitespace-nowrap text-left bg-white",
        title: "sr-only",
        icon: {
          base: "h-6 w-6 transition delay-0 ease-in-out",
          open: {
            on: "rotate-180",
            off: ""
          }
        }
      },
      list: "space-y-2 py-2 bg-white"
    },
    item: {
      base: "flex items-center justify-center rounded-lg p-2 text-base font-normal text-gray-700 hover:bg-gray-100 bg-white",
      active: "bg-gray-100",
      collapsed: {
        insideCollapse: "group w-full pl-8 transition duration-75 bg-white",
        noIcon: "font-bold"
      },
      content: {
        base: "flex-1 whitespace-nowrap px-3 bg-white"
      },
      icon: {
        base: "h-6 w-6 shrink-0 text-gray-500 transition duration-75 group-hover:text-gray-700",
        active: "text-gray-700"
      },
      label: "",
      listItem: ""
    },
    items: {
      base: "bg-white"
    },
    itemGroup: {
      base: "mt-4 space-y-2 border-t border-gray-200 pt-4 first:mt-0 first:border-t-0 first:pt-0 bg-white"
    },
    logo: {
      base: "mb-5 flex items-center pl-2.5 bg-white",
      collapsed: {
        on: "hidden",
        off: "self-center whitespace-nowrap text-xl font-semibold text-gray-900"
      },
      img: "mr-3 h-6 sm:h-7"
    }
  }
};

export default lightTheme;
